import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { RetentionOverviewService } from '../../services/retention-overview.service';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-datenaufbewahrung',
  imports: [TableModule, TagModule, CommonModule, FormsModule, BreadcrumbModule],
  templateUrl: './datenaufbewahrung.html',
  styleUrl: './datenaufbewahrung.scss'
})
export class Datenaufbewahrung implements OnInit {
  public service = inject(RetentionOverviewService);
  protected home: MenuItem = { label: 'Datenaufbewahrung' };
  public cols!: Column[];

  ngOnInit() {
    this.cols = [
      { field: 'created', header: 'Erstellt' },
      { field: 'fallaufgabenName', header: 'Fallaufgabe' },
      { field: 'userId', header: 'Nutzer ID' },
      { field: 'versionsUnique', header: 'Versions Unique' },
      { field: 'isAdminTest', header: 'Testlauf' },
      { field: 'availableUntil', header: 'Verfügbar bis' },
    ];
  }
}
